var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 542.82 448.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8b9635;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.88,95.28h-255.13c-12.3,0-23.61,6.68-29.55,17.44l-122.19,221.7c-4.77,8.67,1.5,19.28,11.39,19.28h255.13c12.3,0,23.61-6.68,29.55-17.44l66.8-121.19h-78.79l-38.38,69.64h-139.54l66.39-120.44h218.31l27.4-49.69c4.79-8.67-1.5-19.3-11.39-19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M408.5,0h-255.13c-12.3,0-23.61,6.68-29.55,17.44L1.63,239.14c-4.77,8.67,1.5,19.28,11.39,19.28h56.75l104.41-189.43h218.31l27.4-49.69c4.79-8.67-1.5-19.3-11.39-19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.32,448.66h255.13c12.3,0,23.61-6.68,29.55-17.44l122.19-221.7c4.77-8.67-1.5-19.28-11.39-19.28h-56.75l-104.41,189.43h-218.31l-27.4,49.69c-4.79,8.67,1.5,19.3,11.39,19.3Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconIo);
export default __webpack_public_path__ + "static/media/logo-icon-io.ea447cee122f22f7ba3859a5f73106a7.svg";
export { ForwardRef as ReactComponent };